export function MessageIcon({
  hasUnread = true,
  className = '',
  size = 44,
}: {
  hasUnread?: boolean;
  className?: string;
  size?: number | string;
}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      height={size}
      viewBox="0 0 44 44"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      {hasUnread ? (
        <>
          <path
            d="M20.1667 5.5H14.3C11.2197 5.5 9.67957 5.5 8.50305 6.09946C7.46816 6.62677 6.62677 7.46816 6.09946 8.50305C5.5 9.67957 5.5 11.2197 5.5 14.3V23.8333C5.5 25.5383 5.5 26.3908 5.68741 27.0902C6.19598 28.9882 7.67849 30.4707 9.5765 30.9793C10.2759 31.1667 11.1284 31.1667 12.8333 31.1667V35.4484C12.8333 36.4253 12.8333 36.9138 13.0336 37.1646C13.2077 37.3828 13.4718 37.5097 13.751 37.5094C14.072 37.5091 14.4534 37.204 15.2162 36.5937L19.5896 33.095C20.4829 32.3803 20.9296 32.023 21.4271 31.7688C21.8684 31.5434 22.3381 31.3786 22.8236 31.279C23.3707 31.1667 23.9428 31.1667 25.0869 31.1667H27.8667C30.947 31.1667 32.4871 31.1667 33.6636 30.5672C34.6985 30.0399 35.5399 29.1985 36.0672 28.1636C36.6667 26.9871 36.6667 25.447 36.6667 22.3667V22"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          />
          <path
            d="M36.8891 5.27766C39.037 7.42554 39.037 10.908 36.8891 13.0558C34.7412 15.2037 31.2588 15.2037 29.1109 13.0558C26.963 10.908 26.963 7.42554 29.1109 5.27766C31.2588 3.12978 34.7412 3.12978 36.8891 5.27766Z"
            fill="#E6332A"
          />
        </>
      ) : (
        <path
          d="M20.1667 5.5H27.8667C30.947 5.5 32.4871 5.5 33.6636 6.09946C34.6985 6.62677 35.5399 7.46816 36.0672 8.50305C36.6667 9.67957 36.6667 18.9197 36.6667 22V22.3667C36.6667 25.447 36.6667 26.9871 36.0672 28.1636C35.5399 29.1985 34.6985 30.0399 33.6636 30.5672C32.4871 31.1667 30.947 31.1667 27.8667 31.1667H25.0869C23.9428 31.1667 23.3707 31.1667 22.8236 31.279C22.3381 31.3786 21.8684 31.5434 21.4271 31.7688C20.9296 32.023 20.4829 32.3803 19.5896 33.095L15.2162 36.5937C14.4534 37.204 14.072 37.5091 13.751 37.5094C13.4718 37.5097 13.2077 37.3828 13.0336 37.1646C12.8333 36.9138 12.8333 36.4253 12.8333 35.4484V31.1667C11.1284 31.1667 10.2759 31.1667 9.5765 30.9793C7.67849 30.4707 6.19598 28.9882 5.68741 27.0902C5.5 26.3908 5.5 25.5383 5.5 23.8333V14.3C5.5 11.2197 5.5 9.67957 6.09946 8.50305C6.62677 7.46816 7.46816 6.62677 8.50305 6.09946C9.67957 5.5 11.2197 5.5 14.3 5.5H20.1667Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
      )}
    </svg>
  );
}
